import * as React from 'react';
import { useHeatingSchedules } from '../../../contexts/heatingSchedules';
import { HeatingSchedule } from '../../../components/schedules/heatingSchedule';
import { HeatingStatus } from './heatingStatus';
import { useDetails } from '../state/detailsContext';

export function HeatingView({ hasNoData }) {
  const { heatingSchedules } = useHeatingSchedules();
  const { zones } = useDetails();

  return (
    <div className="w-full h-full" data-qa="heating-details">
      <div className="flex flex-row flex-wrap" data-qa="heating-items">
        {zones?.map(item => (
          <HeatingStatus key={item.zone_id} {...item} hasNoData={hasNoData} />
        ))}
      </div>
      <div className="p-8">
        <HeatingSchedule zones={zones} title={'Heating Schedules'} schedules={heatingSchedules} />
      </div>
    </div>
  );
}
